import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardQuickSuggestionOption')(function discardQuickSuggestionOption(state) {
    var optionState = state.optionState;
    optionState.smartSuggestionsEnabled = null;
    optionState.browserLocationEnabled = null;
}));
//# sourceMappingURL=discardQuickSuggestionOption.js.map